var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apex-charts',{attrs:{"id":"apexchart responsive-chart","width":_vm.width,"type":_vm.ctype,"options":_vm.options,"series":_vm.series,"height":_vm.height}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }